// Máscara de nomes para relatórios: primeiro nome completo (facilita a leitura — pedido
// do Hilton, 28/07/2026), sobrenomes com o início preservado e o restante oculto.
// Ex.: "Atalita Fernanda Marinho de Azevedo" -> "Atalita Fer**** Mar**** de Aze****"
// Partículas curtas (de, da, dos...) permanecem legíveis.
export const maskName = (name: string): string => {
  if (!name || name.startsWith("(")) return name;
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part, index) => (index === 0 || part.length <= 3 ? part : `${part.slice(0, 3)}****`))
    .join(" ");
};
